<template>
	<span
		class="ai-sparkle"
		:class="[
			`-size-${size}`,
			{ 'is-busy': busy },
		]"
		aria-hidden="true"
	>
		<svg viewBox="0 0 24 24">
			<path
				class="ai-sparkle__star -primary"
				d="M9 2.5c.43 4.18 2.32 6.07 6.5 6.5-4.18.43-6.07 2.32-6.5 6.5-.43-4.18-2.32-6.07-6.5-6.5C6.68 8.57 8.57 6.68 9 2.5Z"
			/>
			<path
				class="ai-sparkle__star -secondary"
				d="M18 11.5c.3 2.91 1.59 4.2 4.5 4.5-2.91.3-4.2 1.59-4.5 4.5-.3-2.91-1.59-4.2-4.5-4.5 2.91-.3 4.2-1.59 4.5-4.5Z"
			/>
			<path
				class="ai-sparkle__star -tertiary"
				d="M17 2c.18 1.82.98 2.62 2.8 2.8-1.82.18-2.62.98-2.8 2.8-.18-1.82-.98-2.62-2.8-2.8 1.82-.18 2.62-.98 2.8-2.8Z"
			/>
		</svg>
	</span>
</template>

<script>
export default {
	name:  'AiSparkle',
	props: {
		busy: {
			type:    Boolean,
			default: false,
		},
		size: {
			type:      String,
			default:   'md',
			validator: value => ['xs', 'sm', 'md', 'lg'].includes(value),
		},
	},
};
</script>

<style lang="scss" scoped>
.ai-sparkle {
	display: inline-flex;
	flex-shrink: 0;
	color: var(--color-ai);

	&.-size-xs {
		width: 14px;
		height: 14px;
	}

	&.-size-sm {
		width: 18px;
		height: 18px;
	}

	&.-size-md {
		width: 24px;
		height: 24px;
	}

	&.-size-lg {
		width: 30px;
		height: 30px;
	}

	svg { // stylelint-disable-line selector-max-type
		overflow: visible;
		width: 100%;
		height: 100%;
		fill: currentColor;
	}
}

.ai-sparkle__star {
	--ai-sparkle-delay: 0ms;

	transform-box: fill-box;
	transform-origin: center;

	.ai-sparkle.is-busy & {
		animation: ai-sparkle-twinkle 1.25s ease-in-out infinite;
		animation-delay: var(--ai-sparkle-delay);
	}

	&.-secondary {
		--ai-sparkle-delay: 160ms;
	}

	&.-tertiary {
		--ai-sparkle-delay: 320ms;
	}
}

@keyframes ai-sparkle-twinkle {
	0%,
	100% {
		opacity: 0.4;
		transform: scale(0.7);
	}

	45% {
		opacity: 1;
		transform: scale(1.12);
	}
}

@media (prefers-reduced-motion: reduce) {
	.ai-sparkle__star {
		animation: none !important; // stylelint-disable-line declaration-no-important
		opacity: 1;
		transform: none;
	}
}
</style>
